export default __webpack_public_path__ + "static/media/Harrow.55e80e1c.jpg";